module.exports = __webpack_public_path__ + "img/logo-cordoba-hoy.15ae345c.png";